export default "__VITE_ASSET__C4jLjy8G__"